document.addEventListener('DOMContentLoaded', () => {
  const rewardsStorageKey = 'mello-rewards-popup-seen-at';
  const rewardsRepeatDelay = 7 * 24 * 60 * 60 * 1000;
  let rewardsAutoOpenScheduled = false;
  let rewardsStateObserver;
  let rewardsReadyTimer;

  const rewardsBackdrop = document.createElement('div');
  rewardsBackdrop.className = 'rewards-modal-backdrop';
  rewardsBackdrop.setAttribute('aria-hidden', 'true');
  document.body.appendChild(rewardsBackdrop);

  const rewardsCloseButton = document.createElement('button');
  rewardsCloseButton.className = 'rewards-modal-close';
  rewardsCloseButton.type = 'button';
  rewardsCloseButton.setAttribute('aria-label', 'Close Rewards');
  rewardsCloseButton.setAttribute('aria-hidden', 'true');
  rewardsCloseButton.tabIndex = -1;
  rewardsCloseButton.textContent = '×';
  document.body.appendChild(rewardsCloseButton);

  const setRewardsBackdropState = (isOpen) => {
    rewardsBackdrop.classList.toggle('is-visible', isOpen);
    rewardsBackdrop.setAttribute('aria-hidden', String(!isOpen));
    rewardsCloseButton.classList.toggle('is-visible', isOpen);
    rewardsCloseButton.setAttribute('aria-hidden', String(!isOpen));
    rewardsCloseButton.tabIndex = isOpen ? 0 : -1;
    document.body.classList.toggle('rewards-modal-open', isOpen);
  };

  const rewardsContentIsReady = (iframe) => {
    try {
      const body = iframe.contentDocument?.body;
      return Boolean(body?.children.length && body.textContent.trim().length > 20);
    } catch (error) {
      return iframe.dataset.rewardsLoaded === 'true';
    }
  };

  const revealRewardsWhenReady = (iframe) => {
    window.clearTimeout(rewardsReadyTimer);
    let attempts = 0;
    const checkContent = () => {
      if (!iframe.classList.contains('open')) return;
      if (rewardsContentIsReady(iframe)) {
        iframe.classList.add('rewards-content-ready');
        setRewardsBackdropState(true);
        return;
      }
      if (attempts >= 300) {
        iframe.classList.remove('open', 'show-close-icon');
        setRewardsBackdropState(false);
        return;
      }
      attempts += 1;
      rewardsReadyTimer = window.setTimeout(checkContent, 100);
    };
    iframe.addEventListener('load', () => {
      iframe.dataset.rewardsLoaded = 'true';
      checkContent();
    }, { once: true });
    checkContent();
  };

  const openRewardsPopup = (remember = true) => {
    const button = document.querySelector('#appstle-loyalty-button');
    const iframe = document.querySelector('#appstle_loyalty_iframe');
    if (!button || !iframe) return false;
    if (!iframe.classList.contains('open')) {
      button.click();
    }
    if (iframe.classList.contains('rewards-content-ready')) setRewardsBackdropState(true);
    else revealRewardsWhenReady(iframe);
    if (remember) {
      try { localStorage.setItem(rewardsStorageKey, String(Date.now())); } catch (error) { /* Storage may be unavailable. */ }
    }
    return true;
  };

  const closeRewardsPopup = () => {
    const button = document.querySelector('#appstle-loyalty-button');
    const iframe = document.querySelector('#appstle_loyalty_iframe');
    if (button && iframe?.classList.contains('open')) button.click();
    window.clearTimeout(rewardsReadyTimer);
    iframe?.classList.remove('open', 'show-close-icon');
    setRewardsBackdropState(false);
  };

  rewardsCloseButton.addEventListener('click', closeRewardsPopup);
  document.querySelectorAll('[data-rewards-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openRewardsPopup();
    });
  });
  rewardsBackdrop.addEventListener('click', closeRewardsPopup);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeRewardsPopup();
  });

  const customizeRewardsLauncher = () => {
    const button = document.querySelector('#appstle-loyalty-button');
    const iframe = document.querySelector('#appstle_loyalty_iframe');
    const title = document.querySelector('#loyalty-widget-title');
    if (!button || !iframe) return false;

    if (title) title.textContent = 'Rewards';
    button.setAttribute('aria-hidden', 'true');
    button.setAttribute('tabindex', '-1');

    if (!rewardsStateObserver) {
      rewardsStateObserver = new MutationObserver(() => {
        const shouldShow = iframe.classList.contains('open') && iframe.classList.contains('rewards-content-ready');
        setRewardsBackdropState(shouldShow);
      });
      rewardsStateObserver.observe(iframe, { attributes: true, attributeFilter: ['class'] });
      setRewardsBackdropState(iframe.classList.contains('open') && iframe.classList.contains('rewards-content-ready'));
    }

    if (!rewardsAutoOpenScheduled && document.body.classList.contains('template-index') && !window.Shopify?.designMode) {
      let lastSeen = 0;
      try { lastSeen = Number(localStorage.getItem(rewardsStorageKey) || 0); } catch (error) { lastSeen = 0; }
      if (Date.now() - lastSeen >= rewardsRepeatDelay) {
        rewardsAutoOpenScheduled = true;
        window.setTimeout(() => {
          if (document.visibilityState === 'visible') openRewardsPopup();
        }, 8000);
      }
    }
    return true;
  };

  if (!customizeRewardsLauncher()) {
    const rewardsObserver = new MutationObserver(() => {
      if (customizeRewardsLauncher()) rewardsObserver.disconnect();
    });
    rewardsObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-collection-filters]').forEach((form) => {
    form.addEventListener('change', (event) => {
      if (event.target.matches('select, input[type="checkbox"]')) form.submit();
    });
  });

  const wishlistKey = 'skimslike-wishlist';
  let wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (error) { wishlist = []; }
  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const handle = button.dataset.productHandle;
    const updateButton = () => button.setAttribute('aria-pressed', String(wishlist.includes(handle)));
    updateButton();
    button.addEventListener('click', () => {
      wishlist = wishlist.includes(handle) ? wishlist.filter((item) => item !== handle) : [...wishlist, handle];
      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      updateButton();
    });
  });

  document.querySelectorAll('[data-recently-track]').forEach((track) => {
    const section = track.closest('.recently-viewed');
    const scrollTrack = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
    section.querySelector('[data-recently-previous]')?.addEventListener('click', () => scrollTrack(-1));
    section.querySelector('[data-recently-next]')?.addEventListener('click', () => scrollTrack(1));
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (toggle && menu) {
    const closeMenu = () => {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900) closeMenu();
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantData = section.querySelector('[data-product-variants]');
    const variantInput = section.querySelector('[data-variant-id]');
    const addButton = section.querySelector('[data-add-to-cart]');
    if (!variantData || !variantInput || !addButton) return;

    const comingSoon = section.dataset.comingSoon === 'true';
    const variants = JSON.parse(variantData.textContent);
    section.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-position]')) return;
      const optionLabel = section.querySelector('[data-option-label-position="' + event.target.dataset.optionPosition + '"]');
      if (optionLabel) optionLabel.textContent = event.target.value;

      const selected = Array.from(section.querySelectorAll('[data-option-position]:checked')).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      addButton.disabled = comingSoon || !variant.available;
      if (!comingSoon) addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      const price = section.querySelector('[data-product-price]');
      if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: section.dataset.currency || 'USD' }).format(variant.price / 100);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });
});
